import HistorySingleton from '../records/HistorySingleton';
export const replace = (...args) => () => {
  HistorySingleton().instance().replace(...args);
};